import $http from '../../shared/http';

export const posts = {
  namespaced: true,
  state: () => {
    return {
      posts: [],
    };
  },

  actions: {
    async LOAD_POSTS(ctx, { orgId }) {
      return $http('v2').get(`organisations/${orgId}/posts`, {
        notifiable: true,
      });
    },

    async CREATE_POST(ctx, { orgId, post_type }) {
      return $http('v2').get(`organisations/${orgId}/posts/${post_type}`, {
        notifiable: true,
      });
    },

    async FETCH_POST_VISIBILITY_TYPES(ctx, { orgId, usage }) {
      return $http('v2').get(`organisations/${orgId}/post_visibility_types`, {
        params: { usage },
      });
    },
  },
};
